<template>
  <div class="columns is-multiline is-variable is-mobile is-5">
    <div class="column" :class="columnClasses" v-for="result in reviewResults" :key="result.id">
      <review-cell-component
        :label="result.getLabel()"
        :value="result.getValue()">
        <template v-slot:actions>
          <report-actions-component
            :result="result"
            class="is-pulled-right review-actions customer"
            v-on:openCommentSection="$emit('openCommentSection', result)"
            v-on:showFinding="$emit('showFinding', result)">
          </report-actions-component>
        </template>
        <template v-slot:dependencies>
          <review-dependency-component
            class="dependencies"
            v-for="(dependency, key) in result.dependencies" :key="key"
            :dependency="dependency">
          </review-dependency-component>
        </template>
      </review-cell-component>
    </div>
  </div>
</template>
<script>
  import ReviewCellComponent from '@/components/layout/custom_grid/ReviewCellComponent.vue'
  import ReviewDependencyComponent from '@/components/layout/custom_grid/ReviewDependencyComponent.vue'
  import ReportActionsComponent from '@/components/layout/case_report/ReportActionsComponent'

  export default {
    name: 'review-report-grid-component',
    components: {
      ReviewCellComponent,
      ReviewDependencyComponent,
      ReportActionsComponent
    },
    props: {
      reviewResults: {
        type: Array,
        required: true
      },
      columnClasses: {
        type: String,
        default: 'is-6-mobile is-4-tablet is-3-desktop'
      }
    }
  }
</script>
<style lang="sass" scoped></style>
